// Dumb grid — no store, no SQL, no API, no router, no analytics, no table names. issue-analysis's
// issues grid, moved here from the app (`components/grids/IssuesGrid.vue`) on 2026-10-12 under
// the rule "an app's src/components/ holds only pages" (PLATFORM.md §3.2 rule 9). It renders
// @rdrive/plugin-data-table's DuckDbDataTable — paging, page size, sort, the debounced search
// (500 ms), the filter-context / dataLoaded / reloadKey reloads and both layouts are the table's —
// and keeps what is issue-row specific: the headers, the issue row (photo stack, due-by chip, deep
// links, status/assignee/updated column), the mobile card, which photos the photo dialog shows
// (the dialog itself is the sibling ItemPhotoDialog since AM_ABSORPTION_PLAN step C5a — its
// markup moved there unchanged), and the report button + the sibling
// ItemsGridPaginatedReportsDialog. Every query, the report and the link opener are the app's,
// through the function props below.
//
//   props:  filterContext        (Object, required)  duck type { filtersLastUpdated, ... }; a tick
//                                     reloads from page 1 (the table's `filterContext`)
//           dataLoaded           (Boolean)  false → true reloads from page 1; it gates nothing
//           fetchPage            (Function, required) ({ page, itemsPerPage, sort, search })
//                                     -> { items, totalItems }; the table's provider, as is
//           reloadKey            (any)      a change reloads from page 1 (the app's conditions)
//           apiHost              (String)   host with any leading 'api-' ALREADY stripped
//           projectCode          (String)
//           openUrl              (Function) every deep link; defaults to window.open(url, '_blank')
//           generateReport       (Function|null) awaited with the dialog's options; null hides
//                                     the download button and the dialog
//           reportBusy           (Boolean)  the report dialog's spinner
//           reportDisabledModes  (Array)    → the dialog's `disabledModes`
//           reportGroupByOptions (Array)    → the dialog's `groupByOptions` ([{ title, value }])
//           reportOrderByOptions (Array)    → the dialog's `orderByOptions`
//   emits:  none. Filtering happens through the filterContext the page owns.
//
// Full contract (row shape, sort keys): ../../../README.md. The logic lives in ./setup.js.
import { DuckDbDataTable } from '@rdrive/plugin-data-table';
import ItemsGridPaginatedReportsDialog from '../ItemsGridPaginatedReportsDialog/component.vue';
import ItemPhotoDialog from '../ItemPhotoDialog/component.vue';
import setup from './setup.js';

export default {
  name: 'issues-grid',
  props: {
    filterContext: {
      type: Object,
      required: true
    },
    dataLoaded: {
      type: Boolean,
      default: false
    },
    fetchPage: {
      type: Function,
      required: true
    },
    // Any value; a change reloads the table from page 1
    reloadKey: {
      type: null,
      default: null
    },
    // Already stripped of a leading 'api-' by the app
    apiHost: {
      type: String,
      default: ''
    },
    projectCode: {
      type: String,
      default: ''
    },
    openUrl: {
      type: Function,
      default: (url) => window.open(url, '_blank')
    },
    // null/undefined hides the download button and the dialog
    generateReport: {
      type: Function,
      default: null
    },
    reportBusy: {
      type: Boolean,
      default: false
    },
    reportDisabledModes: {
      type: Array,
      default: () => []
    },
    reportGroupByOptions: {
      type: Array,
      default: () => []
    },
    reportOrderByOptions: {
      type: Array,
      default: () => []
    }
  },
  components: { DuckDbDataTable, ItemsGridPaginatedReportsDialog, ItemPhotoDialog },
  setup,
};
